import { api } from "./api";

export interface RelatorioMovimento {
  id: string;
  horario: string;
  print_url: string;
  pessoas_qg: number;
  id_militar_criador: string;
  militarCriador: any;
  oficiaisOnline: any[];
  created_at: string;
  updated_at: string;
}

export interface RelatorioMovimentoResponsavel {
  id: string;
  id_militar: string;
  militar: any;
  data_hora_inicio: string;
  data_hora_termino: string | null;
  status: string;
  data_hora_pausa: string | null;
  tempo_pausado_segundos: number;
  created_at: string;
  updated_at: string;
}

export const relatorioMovimentoService = {
  // Responsabilidade RM
  async getResponsavelAtual() {
    const response = await api.get("/relatorio-movimento/responsavel/atual");
    return response.data;
  },

  async iniciarRM() {
    const response = await api.post("/relatorio-movimento/responsavel/iniciar");
    return response.data;
  },

  async pegarRM() {
    const response = await api.post("/relatorio-movimento/responsavel/pegar");
    return response.data;
  },

  async pausarRM() {
    const response = await api.patch("/relatorio-movimento/responsavel/pausar");
    return response.data;
  },

  async retomarRM() {
    const response = await api.patch("/relatorio-movimento/responsavel/retomar");
    return response.data;
  },

  async finalizarRM() {
    const response = await api.delete("/relatorio-movimento/responsavel/finalizar");
    return response.data;
  },

  async getHistoricoResponsaveis(params?: {
    data_inicio?: string;
    data_fim?: string;
    page?: number;
    limit?: number;
  }) {
    const response = await api.get("/relatorio-movimento/responsavel/historico", { params });
    return response.data;
  },

  // Relatórios RM
  async create(data: { horario: string; pessoas_qg: string; print_url?: string; oficiais_online: string[] }) {
    const response = await api.post("/relatorio-movimento", data);
    return response.data;
  },

  async findAll(params?: {
    data_inicio?: string;
    data_fim?: string;
    page?: number;
    limit?: number;
  }) {
    const response = await api.get("/relatorio-movimento", { params });
    return response.data;
  },

  async findById(id: string) {
    const response = await api.get(`/relatorio-movimento/${id}`);
    return response.data;
  },

  async delete(id: string) {
    const response = await api.delete(`/relatorio-movimento/${id}`);
    return response.data;
  },
};
